// extracted by mini-css-extract-plugin
module.exports = {"chip":"widget-space--chip--1QC08","content":"widget-space--content--3WECU","action":"widget-space--action--NA09_"};